import React, { useContext } from 'react'
import { Fa, TextBody } from '@eltoro-ui/components'
import classNames from 'classnames'
import { ThemeContext } from 'Contexts'

export const ErrorMsg = ({
  children,
  className,
  title,
}: {
  children: React.ReactNode
  className?: string
  title?: React.ReactNode
}) => {
  const { name: theme } = useContext(ThemeContext)

  return (
    <div
      className={classNames(
        'ErrorMsg bg-danger-600 text-danger mt-4 flex gap-4 rounded-md p-4',
        { 'bg-danger-300': theme === 'darkBlue' || theme === 'dark' },
        className,
      )}
    >
      <Fa icon="circle-exclamation text-[color:var(--color-white)]" size={3} />
      <div>
        <TextBody className="text-white" type={1}>
          <strong>{title || 'Oh no!'}</strong>
        </TextBody>
        <TextBody className="text-white" type={2}>
          {children}
        </TextBody>
      </div>
    </div>
  )
}
